/** Public site (e.g. Next.js on Vercel). Used when this app runs inside an iframe so links update the parent URL bar. */
export const CANONICAL_SITE_URL = (
  process.env.REACT_APP_CANONICAL_SITE_URL
).replace(/\/$/, '');
